<template>
    <div class="editor-container">
        <Toolbar class="editor-toolbar" :editor="editorRef" :defaultConfig="toolbarConfig" />
        <Editor class="editor-content" v-model="valueHtml" :defaultConfig="editorConfig" @onCreated="handleCreated"
            @onChange="handleChange" />
    </div>
</template>

<script setup>
import '@wangeditor/editor/dist/css/style.css'
import { onBeforeUnmount, ref, shallowRef, defineExpose, defineEmits } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
const emit = defineEmits();
const editorRef = shallowRef()
const valueHtml = ref('')

const toolbarConfig = {
    excludeKeys: [
        'insertImage',  // 图片
        'insertTable',  // 表格
        'codeBlock',    // 代码块
        'code',         // 行内代码（如果需要也禁用）
        'group-image',  // 图片组（如果有）
        'group-video',   // 视频组（通常也一起禁用）
		'fullScreen'
    ]
}

const editorConfig = {
    placeholder: '请输入内容...',
    MENU_CONF: {
        uploadImage: {
            server: '/api/upload',
            fieldName: 'file',
            maxFileSize: 3 * 1024 * 1024,
            allowedFileTypes: ['image/*'],
            customInsert(res, insertFn) {
                insertFn(res.data.url, res.data.alt, res.data.href)
            }
        }
    }
}

const setValue = (html) => {
    valueHtml.value = html
}

const handleCreated = (editor) => {
    editorRef.value = editor
}

const handleChange = (editor) => {
    // console.log('内容变化:', editor.getHtml())
    emit('change', editor.getHtml())
}

onBeforeUnmount(() => {
    const editor = editorRef.value
    if (editor == null) return
    editor.destroy()
})

defineExpose({
    setValue
})
</script>

<style>
.editor-container {
    border: 1px solid #ddd;
    border-radius: 4px;
    margin: 20px 0;
}

.editor-toolbar {
    border-bottom: 1px solid #ddd;
}

.editor-content {
    min-height: 400px;
    max-height: 600px;
    overflow-y: auto;
}

.editor-preview {
    padding: 20px;
    border-top: 1px solid #eee;
    margin-top: 20px;
}
</style>